// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1R86_","header":"Messages_header__1PYIE"};